// UI translations for L'Oasis Restaurant
// Languages: fr, en, de, es, pt, it, nl

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "nl", label: "Nederlands", flag: "NL" },
];

export const t = {
  fr: {
    nav_home: "Accueil",
    nav_restaurant: "Carte Restaurant",
    nav_gourmandise: "Carte Gourmandise",
    hero_kicker: "Bienvenue à",
    hero_title: "L'Oasis",
    hero_subtitle: "Une parenthèse tropicale au cœur de la gourmandise",
    hero_description:
      "Découvrez une cuisine de saison aux saveurs ensoleillées, des poke bowls aux planches à partager, des cocktails signatures aux glaces artisanales.",
    hero_cta_restaurant: "Voir la carte restaurant",
    hero_cta_gourmandise: "Voir la carte gourmandise",
    explore_title: "Nos deux univers",
    explore_subtitle: "Choisissez votre voyage gustatif",
    card_restaurant_title: "Carte Restaurant",
    card_restaurant_desc: "Poke bowls, woks, fruits de mer, viandes, burgers, vins et menus signature.",
    card_gourmandise_title: "Carte Gourmandise",
    card_gourmandise_desc: "Glaces artisanales, crêpes, gaufres, cocktails et boissons rafraîchissantes.",
    discover: "Découvrir",
    info_title: "Nous rendre visite",
    info_address: "Adresse",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Téléphone",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Horaires",
    info_hours_value: "Lun – Dim · 10h00 – 23h30",
    info_follow: "Suivez-nous",
    footer_tagline: "L'oasis de saveurs sous les tropiques",
    footer_rights: "Tous droits réservés",
    back_home: "Retour à l'accueil",
    section_label: "Section",
    price: "Prix",
    menu_intro_restaurant:
      "Une cuisine généreuse inspirée des saveurs du monde, élaborée avec des produits frais et de saison.",
    menu_intro_gourmandise:
      "Un voyage sucré et rafraîchissant — glaces artisanales, crêpes moelleuses, cocktails créatifs.",
    card_label: "L'Oasis · Carte",
    section_count: "Section",
    featured_title: "Nos Menus",
    featured_subtitle: "Découvrez nos formules signature",
  },
  en: {
    nav_home: "Home",
    nav_restaurant: "Restaurant Menu",
    nav_gourmandise: "Sweet Menu",
    hero_kicker: "Welcome to",
    hero_title: "L'Oasis",
    hero_subtitle: "A tropical escape in the heart of indulgence",
    hero_description:
      "Discover seasonal cuisine with sun-kissed flavors — from poke bowls to sharing boards, signature cocktails to artisanal ice creams.",
    hero_cta_restaurant: "View Restaurant Menu",
    hero_cta_gourmandise: "View Sweet Menu",
    explore_title: "Our two worlds",
    explore_subtitle: "Choose your taste journey",
    card_restaurant_title: "Restaurant Menu",
    card_restaurant_desc: "Poke bowls, woks, seafood, meats, burgers, wines and signature menus.",
    card_gourmandise_title: "Sweet Menu",
    card_gourmandise_desc: "Artisanal ice creams, crêpes, waffles, cocktails and refreshing drinks.",
    discover: "Discover",
    info_title: "Visit us",
    info_address: "Address",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Phone",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Opening hours",
    info_hours_value: "Mon – Sun · 10:00 AM – 11:30 PM",
    info_follow: "Follow us",
    footer_tagline: "The oasis of tropical flavors",
    footer_rights: "All rights reserved",
    back_home: "Back to home",
    section_label: "Section",
    price: "Price",
    menu_intro_restaurant:
      "Generous cuisine inspired by world flavors, crafted with fresh, seasonal ingredients.",
    menu_intro_gourmandise:
      "A sweet & refreshing journey — artisanal ice creams, soft crêpes, creative cocktails.",
    card_label: "L'Oasis · Menu",
    section_count: "Section",
    featured_title: "Our Set Menus",
    featured_subtitle: "Discover our signature menus",
  },
  de: {
    nav_home: "Startseite",
    nav_restaurant: "Restaurantkarte",
    nav_gourmandise: "Süße Karte",
    hero_kicker: "Willkommen im",
    hero_title: "L'Oasis",
    hero_subtitle: "Eine tropische Auszeit im Herzen des Genusses",
    hero_description:
      "Entdecken Sie eine saisonale Küche mit sonnigen Aromen — von Poke Bowls bis zu Sharing Boards, Signature-Cocktails und handgemachtem Eis.",
    hero_cta_restaurant: "Restaurantkarte ansehen",
    hero_cta_gourmandise: "Süße Karte ansehen",
    explore_title: "Unsere zwei Welten",
    explore_subtitle: "Wählen Sie Ihre Geschmacksreise",
    card_restaurant_title: "Restaurantkarte",
    card_restaurant_desc: "Poke Bowls, Woks, Meeresfrüchte, Fleisch, Burger, Weine und Signature-Menüs.",
    card_gourmandise_title: "Süße Karte",
    card_gourmandise_desc: "Handgemachtes Eis, Crêpes, Waffeln, Cocktails und erfrischende Getränke.",
    discover: "Entdecken",
    info_title: "Besuchen Sie uns",
    info_address: "Adresse",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Telefon",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Öffnungszeiten",
    info_hours_value: "Mo – So · 10:00 – 23:30 Uhr",
    info_follow: "Folgen Sie uns",
    footer_tagline: "Die Oase tropischer Aromen",
    footer_rights: "Alle Rechte vorbehalten",
    back_home: "Zurück zur Startseite",
    section_label: "Bereich",
    price: "Preis",
    menu_intro_restaurant:
      "Großzügige Küche, inspiriert von Aromen aus aller Welt, zubereitet mit frischen, saisonalen Zutaten.",
    menu_intro_gourmandise:
      "Eine süße & erfrischende Reise — handgemachtes Eis, weiche Crêpes, kreative Cocktails.",
    card_label: "L'Oasis · Karte",
    section_count: "Bereich",
    featured_title: "Unsere Menüs",
    featured_subtitle: "Entdecken Sie unsere Signature-Menüs",
  },
  es: {
    nav_home: "Inicio",
    nav_restaurant: "Carta Restaurante",
    nav_gourmandise: "Carta Dulce",
    hero_kicker: "Bienvenido a",
    hero_title: "L'Oasis",
    hero_subtitle: "Un escape tropical en el corazón del placer",
    hero_description:
      "Descubre una cocina de temporada con sabores soleados — desde poke bowls hasta tablas para compartir, cócteles de autor y helados artesanales.",
    hero_cta_restaurant: "Ver carta restaurante",
    hero_cta_gourmandise: "Ver carta dulce",
    explore_title: "Nuestros dos mundos",
    explore_subtitle: "Elige tu viaje gastronómico",
    card_restaurant_title: "Carta Restaurante",
    card_restaurant_desc: "Poke bowls, woks, mariscos, carnes, hamburguesas, vinos y menús de autor.",
    card_gourmandise_title: "Carta Dulce",
    card_gourmandise_desc: "Helados artesanales, crepes, gofres, cócteles y bebidas refrescantes.",
    discover: "Descubrir",
    info_title: "Visítanos",
    info_address: "Dirección",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Teléfono",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Horario",
    info_hours_value: "Lun – Dom · 10:00 – 23:30",
    info_follow: "Síguenos",
    footer_tagline: "El oasis de los sabores tropicales",
    footer_rights: "Todos los derechos reservados",
    back_home: "Volver al inicio",
    section_label: "Sección",
    price: "Precio",
    menu_intro_restaurant:
      "Cocina generosa inspirada en los sabores del mundo, elaborada con productos frescos y de temporada.",
    menu_intro_gourmandise:
      "Un viaje dulce y refrescante — helados artesanales, crepes suaves, cócteles creativos.",
    card_label: "L'Oasis · Carta",
    section_count: "Sección",
    featured_title: "Nuestros Menús",
    featured_subtitle: "Descubre nuestros menús de autor",
  },
  pt: {
    nav_home: "Início",
    nav_restaurant: "Carta Restaurante",
    nav_gourmandise: "Carta Doce",
    hero_kicker: "Bem-vindo ao",
    hero_title: "L'Oasis",
    hero_subtitle: "Um refúgio tropical no coração do prazer",
    hero_description:
      "Descubra uma cozinha sazonal com sabores ensolarados — de poke bowls a tábuas para partilhar, cocktails de autor e gelados artesanais.",
    hero_cta_restaurant: "Ver carta restaurante",
    hero_cta_gourmandise: "Ver carta doce",
    explore_title: "Os nossos dois mundos",
    explore_subtitle: "Escolha a sua viagem gastronómica",
    card_restaurant_title: "Carta Restaurante",
    card_restaurant_desc: "Poke bowls, woks, marisco, carnes, hambúrgueres, vinhos e menus de autor.",
    card_gourmandise_title: "Carta Doce",
    card_gourmandise_desc: "Gelados artesanais, crepes, waffles, cocktails e bebidas refrescantes.",
    discover: "Descobrir",
    info_title: "Visite-nos",
    info_address: "Morada",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Telefone",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Horário",
    info_hours_value: "Seg – Dom · 10:00 – 23:30",
    info_follow: "Siga-nos",
    footer_tagline: "O oásis dos sabores tropicais",
    footer_rights: "Todos os direitos reservados",
    back_home: "Voltar ao início",
    section_label: "Secção",
    price: "Preço",
    menu_intro_restaurant:
      "Cozinha generosa inspirada nos sabores do mundo, elaborada com produtos frescos e da época.",
    menu_intro_gourmandise:
      "Uma viagem doce e refrescante — gelados artesanais, crepes macios, cocktails criativos.",
    card_label: "L'Oasis · Carta",
    section_count: "Secção",
    featured_title: "Os Nossos Menus",
    featured_subtitle: "Descubra os nossos menus de autor",
  },
  it: {
    nav_home: "Home",
    nav_restaurant: "Menu Ristorante",
    nav_gourmandise: "Menu Dolce",
    hero_kicker: "Benvenuti a",
    hero_title: "L'Oasis",
    hero_subtitle: "Una fuga tropicale nel cuore del piacere",
    hero_description:
      "Scopri una cucina stagionale dai sapori solari — dalle poke bowl ai taglieri da condividere, cocktail d'autore e gelati artigianali.",
    hero_cta_restaurant: "Vedi menu ristorante",
    hero_cta_gourmandise: "Vedi menu dolce",
    explore_title: "I nostri due mondi",
    explore_subtitle: "Scegli il tuo viaggio del gusto",
    card_restaurant_title: "Menu Ristorante",
    card_restaurant_desc: "Poke bowl, wok, frutti di mare, carni, hamburger, vini e menu d'autore.",
    card_gourmandise_title: "Menu Dolce",
    card_gourmandise_desc: "Gelati artigianali, crêpe, waffle, cocktail e bevande rinfrescanti.",
    discover: "Scopri",
    info_title: "Vieni a trovarci",
    info_address: "Indirizzo",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Telefono",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Orari",
    info_hours_value: "Lun – Dom · 10:00 – 23:30",
    info_follow: "Seguici",
    footer_tagline: "L'oasi dei sapori tropicali",
    footer_rights: "Tutti i diritti riservati",
    back_home: "Torna alla home",
    section_label: "Sezione",
    price: "Prezzo",
    menu_intro_restaurant:
      "Cucina generosa ispirata ai sapori del mondo, preparata con prodotti freschi e di stagione.",
    menu_intro_gourmandise:
      "Un viaggio dolce e rinfrescante — gelati artigianali, crêpe morbide, cocktail creativi.",
    card_label: "L'Oasis · Menù",
    section_count: "Sezione",
    featured_title: "I Nostri Menù",
    featured_subtitle: "Scopri i nostri menù d'autore",
  },
  nl: {
    nav_home: "Home",
    nav_restaurant: "Restaurantkaart",
    nav_gourmandise: "Zoete Kaart",
    hero_kicker: "Welkom bij",
    hero_title: "L'Oasis",
    hero_subtitle: "Een tropische ontsnapping in het hart van het genot",
    hero_description:
      "Ontdek een seizoenskeuken met zonnige smaken — van poke bowls tot deelplanken, signature cocktails en ambachtelijk ijs.",
    hero_cta_restaurant: "Bekijk restaurantkaart",
    hero_cta_gourmandise: "Bekijk zoete kaart",
    explore_title: "Onze twee werelden",
    explore_subtitle: "Kies je smaakreis",
    card_restaurant_title: "Restaurantkaart",
    card_restaurant_desc: "Poke bowls, woks, zeevruchten, vlees, burgers, wijnen en signature menu's.",
    card_gourmandise_title: "Zoete Kaart",
    card_gourmandise_desc: "Ambachtelijk ijs, crêpes, wafels, cocktails en verfrissende dranken.",
    discover: "Ontdekken",
    info_title: "Bezoek ons",
    info_address: "Adres",
    info_address_value: "6 Prom. du Front de Mer, 11100 Narbonne",
    info_phone: "Telefoon",
    info_phone_value: "04 68 49 12 18",
    info_hours: "Openingstijden",
    info_hours_value: "Ma – Zo · 10:00 – 23:30",
    info_follow: "Volg ons",
    footer_tagline: "De oase van tropische smaken",
    footer_rights: "Alle rechten voorbehouden",
    back_home: "Terug naar home",
    section_label: "Sectie",
    price: "Prijs",
    menu_intro_restaurant:
      "Royale keuken geïnspireerd door smaken uit de hele wereld, bereid met verse, seizoensgebonden ingrediënten.",
    menu_intro_gourmandise:
      "Een zoete en verfrissende reis — ambachtelijk ijs, zachte crêpes, creatieve cocktails.",
    card_label: "L'Oasis · Kaart",
    section_count: "Sectie",
    featured_title: "Onze Menu's",
    featured_subtitle: "Ontdek onze signature menu's",
  },
};

// Section header translations (for menu categories)
export const sectionT = {
  // Restaurant sections
  planches: { fr: "Planches à partager", en: "Sharing boards", de: "Sharing-Platten", es: "Tablas para compartir", pt: "Tábuas para partilhar", it: "Taglieri da condividere", nl: "Deelplanken" },
  poke: { fr: "Poke Bowls", en: "Poke Bowls", de: "Poke Bowls", es: "Poke Bowls", pt: "Poke Bowls", it: "Poke Bowls", nl: "Poke Bowls" },
  woks: { fr: "Woks", en: "Woks", de: "Woks", es: "Woks", pt: "Woks", it: "Wok", nl: "Woks" },
  fruitsMer: { fr: "Fruits de mer", en: "Seafood", de: "Meeresfrüchte", es: "Mariscos", pt: "Marisco", it: "Frutti di mare", nl: "Zeevruchten" },
  poissons: { fr: "Poissons & Moules", en: "Fish & Mussels", de: "Fisch & Muscheln", es: "Pescados y Mejillones", pt: "Peixes e Mexilhões", it: "Pesce e Cozze", nl: "Vis & Mosselen" },
  entrees: { fr: "Entrées", en: "Starters", de: "Vorspeisen", es: "Entrantes", pt: "Entradas", it: "Antipasti", nl: "Voorgerechten" },
  salades: { fr: "Salades repas", en: "Meal Salads", de: "Hauptgang-Salate", es: "Ensaladas completas", pt: "Saladas completas", it: "Insalate complete", nl: "Maaltijdsalades" },
  viandes: { fr: "Viandes", en: "Meats", de: "Fleisch", es: "Carnes", pt: "Carnes", it: "Carni", nl: "Vlees" },
  burgers: { fr: "Nos Burgers", en: "Our Burgers", de: "Unsere Burger", es: "Nuestras Hamburguesas", pt: "Os nossos Hambúrgueres", it: "I nostri Burger", nl: "Onze Burgers" },
  menus: { fr: "Menus", en: "Set Menus", de: "Menüs", es: "Menús", pt: "Menus", it: "Menù", nl: "Menu's" },
  desserts: { fr: "Desserts Maison", en: "Homemade Desserts", de: "Hausgemachte Desserts", es: "Postres caseros", pt: "Sobremesas caseiras", it: "Dolci della casa", nl: "Huisgemaakte desserts" },
  vins: { fr: "Vins", en: "Wines", de: "Weine", es: "Vinos", pt: "Vinhos", it: "Vini", nl: "Wijnen" },
  // Gourmandise sections
  glacier: { fr: "Glacier", en: "Ice Cream Parlor", de: "Eisdiele", es: "Heladería", pt: "Gelataria", it: "Gelateria", nl: "IJssalon" },
  smoothies: { fr: "Smoothies, Frappés & Thés glacés", en: "Smoothies, Frappés & Iced Teas", de: "Smoothies, Frappés & Eistees", es: "Smoothies, Frappés y Tés helados", pt: "Smoothies, Frappés e Chás gelados", it: "Smoothies, Frappé e Tè freddi", nl: "Smoothies, Frappés en IJsthee" },
  glaces: { fr: "Glaces signature", en: "Signature Ice Creams", de: "Signature-Eisbecher", es: "Helados de autor", pt: "Gelados de autor", it: "Gelati d'autore", nl: "Signature ijscoupes" },
  crepes: { fr: "Crêpes & Gaufres", en: "Crêpes & Waffles", de: "Crêpes & Waffeln", es: "Crepes y Gofres", pt: "Crepes e Waffles", it: "Crêpe e Waffle", nl: "Crêpes & Wafels" },
  cocktails: { fr: "Cocktails Alcoolisés", en: "Cocktails", de: "Cocktails", es: "Cócteles", pt: "Cocktails", it: "Cocktail", nl: "Cocktails" },
  mocktails: { fr: "Cocktails sans alcool", en: "Mocktails", de: "Alkoholfreie Cocktails", es: "Mocktails", pt: "Mocktails", it: "Mocktail analcolici", nl: "Alcoholvrije cocktails" },
  bieres: { fr: "Bières", en: "Beers", de: "Biere", es: "Cervezas", pt: "Cervejas", it: "Birre", nl: "Bieren" },
  aperitifs: { fr: "Apéritifs & Alcools", en: "Aperitifs & Spirits", de: "Aperitifs & Spirituosen", es: "Aperitivos y Licores", pt: "Aperitivos e Bebidas espirituosas", it: "Aperitivi e Liquori", nl: "Aperitieven & Sterke drank" },
  digestifs: { fr: "Digestifs", en: "Digestifs", de: "Digestifs", es: "Digestivos", pt: "Digestivos", it: "Digestivi", nl: "Digestieven" },
  softs: { fr: "Jus & Sodas", en: "Juices & Sodas", de: "Säfte & Limonaden", es: "Zumos y Refrescos", pt: "Sumos e Refrigerantes", it: "Succhi e Bibite", nl: "Sappen & Frisdrank" },
  chaudes: { fr: "Boissons chaudes", en: "Hot Drinks", de: "Heiße Getränke", es: "Bebidas calientes", pt: "Bebidas quentes", it: "Bevande calde", nl: "Warme dranken" },
};

export const useT = (lang) => t[lang] || t.fr;
